// extracted by mini-css-extract-plugin
export default {"Container":"O_RvSSa47B5uyTPCpOaO","BrandContainer":"q10r8mNOvq0TuI8RrpqM","WorkspaceItem":"WzMmcz7n66euXlcS_4XR","Actions":"pvumwoekPq9t8pRyi9xV","IconAction":"QwgGbOKa2dRJ2BObabN3"};